import { Grid } from '@material-ui/core';
import { Button, Col, Row, } from 'antd';
import React  from 'react';
import DetailItem from '../../../../../CSIComponents/DetailItem';
import styles from '../../../index.module.css'

const RoomDetailView = (props: any) => {
  const detailData = [
        { label: 'Room Id', value: props.currentLine.id || '', span: 6 },
        { label: 'Room Name', value: props.currentLine.name || '' , span: 6 },
        { label: 'Total Space', value: props.currentLine.area || '' , span: 6 },
        
        { span: 5 },
        { label: 'Length', value: props.currentLine.length || '' , span: 6 },
        { label: 'Width', value: props.currentLine.width || '' , span: 6 },
        { label: 'Height', value: props.currentLine.height || '' , span: 6 },
        
        { span: 5 },   
        { label: 'Unit of Measure', value: props.currentLine.uom || '' , span: 6 },
        { label: 'Rank', value: props.currentLine.rank || '' , span: 6 },
        { label: 'Room Decor', value: props.currentLine.decor || '' , span: 6 },
        
        { span: 5 },   
        { label: 'Minimum Charge', value: props.currentLine.mincharge || '' , span: 6 },
        { label: 'Number of 10x10 Exhibits', value: props.currentLine['tenbytenexhibit'] || '' , span: 6 },
        { label: 'Open Square Capacity', value: props.currentLine.onesquarecapacity , span: 6 },
        
        { span: 5 },   
        { label: 'Other Capacity', value: props.currentLine.othercapacity || '' , span: 6 },
        { label: 'Largest Capacity', value: props.currentLine.largestcapacity || '' , span: 6 },
        
        { span: 5 },
        { label: 'Description', value: props.currentLine.description || '' , span: 18 },
    ]

  
  return (
        <div className={styles.outCon}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{margin: '0 10px 0 0'}}>
              <Button type='primary' className='db-edit-btn' onClick={() => {props.setMeetingroomTabsActivityKey('2'); props.setCurrentOneNav('orign')}}>Back</Button>
              </div>
              <div>
              <Button type='primary' className='db-edit-btn' onClick={() => {props.setRoomDetailEditFlag(true); window.editFunction(); props.setTableOneNavDisabled(true)}}>Edit</Button>
              </div>
            </div>
            <div className={styles.inCon}>
                <div className={styles.tableName}>{props.currentLine.name}</div>
            </div>
            <Grid item xs={12} className={styles.pdLeft}>
                <Row gutter={24}>
                {detailData.map((item:any, i:any) => {
                    return item.label ? <Col span={item.span} key={i} className="col-margin">
                    <DetailItem value={item.value} label={item.label} />
                    </Col> : <Col span={item.span} key={i}></Col>
                })
                }
                </Row>
            </Grid>
        </div>
    )
}
export default RoomDetailView;